export default __webpack_public_path__ + "static/media/include_13_male@3x.6c51a833.jpg";